(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/remaining-rows/assets/javascripts/remaining-rows.js') >= 0) return;  svs.modules.push('/components/tipsen/remaining-rows/assets/javascripts/remaining-rows.js');
"use strict";

const {
  ProgressBar
} = svs.components.lbUi.progressBar;
const {
  useDrawForecast
} = svs.components.tipsen.hooksWager;
const {
  Currency: formatCurrency
} = svs.utils.format;
const RemainingRows = _ref => {
  var _drawForecast$current, _drawForecast$current2, _drawForecast$current3, _drawForecast$current4;
  let {
    className,
    drawNumber,
    productId
  } = _ref;
  const winRowsClassNames = ['pg_remaining_rows'];
  if (className) {
    winRowsClassNames.push(className);
  }
  const drawForecast = useDrawForecast({
    productId,
    drawNumber
  });
  const numRemainingRows = (_drawForecast$current = drawForecast === null || drawForecast === void 0 || (_drawForecast$current2 = drawForecast.currentData) === null || _drawForecast$current2 === void 0 ? void 0 : _drawForecast$current2.numRemainingRows) !== null && _drawForecast$current !== void 0 ? _drawForecast$current : 0;
  const totNumPartRows = (_drawForecast$current3 = drawForecast === null || drawForecast === void 0 || (_drawForecast$current4 = drawForecast.currentData) === null || _drawForecast$current4 === void 0 ? void 0 : _drawForecast$current4.totNumPartRows) !== null && _drawForecast$current3 !== void 0 ? _drawForecast$current3 : 0;
  if (!numRemainingRows) {
    winRowsClassNames.push('pg_remaining_rows--no_display');
  }
  return React.createElement("div", {
    className: winRowsClassNames.join(' ')
  }, React.createElement("span", {
    className: "pg_remaining_rows__text"
  }, "Totalt antal rader kvar med chans p\xE5 13 r\xE4tt:", ' ', formatCurrency(numRemainingRows), ' ', "st"), React.createElement(ProgressBar, {
    currValue: numRemainingRows,
    maxValue: totNumPartRows,
    minValue: 0
  }));
};
setGlobal('svs.components.tipsen.remainingRows.RemainingRows', RemainingRows);

 })(window);